// ============================================
// PLAYERS
// ============================================

export const PLAYERS = [
  "green",
  "yellow",
  "blue",
  "red",
];


// ============================================
// TOKENS PER PLAYER
// ============================================

export const TOKENS_PER_PLAYER = 4;


// ============================================
// TOKEN STATUS
// ============================================

export const TOKEN_STATUS = {
  HOME: "home",
  ACTIVE: "active",
  FINISHED: "finished",
};


// ============================================
// TURN ORDER
// ============================================

export const TURN_ORDER = [
  "green",
  "yellow",
  "blue",
  "red",
];


// ============================================
// HOME TOKEN POSITIONS
// ============================================

export const HOME_POSITIONS = {

  green: [
    { left: "14%", top: "14%" },
    { left: "25%", top: "14%" },
    { left: "14%", top: "25%" },
    { left: "25%", top: "25%" },
  ],

  yellow: [
    { left: "74%", top: "14%" },
    { left: "86%", top: "14%" },
    { left: "74%", top: "25%" },
    { left: "86%", top: "25%" },
  ],

  red: [
    { left: "14%", top: "74%" },
    { left: "25%", top: "74%" },
    { left: "14%", top: "86%" },
    { left: "25%", top: "86%" },
  ],

  blue: [
    { left: "74%", top: "74%" },
    { left: "86%", top: "74%" },
    { left: "74%", top: "86%" },
    { left: "86%", top: "86%" },
  ],
};